module.exports = __webpack_public_path__ + "static/media/only_for_you.a450bbd3.png";